const appConst = {
    // apiBaseUrl: "http://localhost:9001", // Test
    // apiBaseUrl: "https://cp.avanue.ai/api", //avanue Live
    apiBaseUrl: "https://ibsportal.avanue.ai/api", // avaniko Live
};

export default appConst;